const initialState = {
    statusShow: false,
};
const modalRankGuide = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_RANK_GUIDE':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_RANK_GUIDE':
            return {...state, statusShow: false};
        default:
            return state;
    }
};

export default modalRankGuide;